import { Link } from 'react-router-dom';
import { Image } from 'shared/components';
import { routeConstants } from 'shared/constants';

const SliderProductItem = ({
  brandName,
  name,
  basePrice,
  basePriceWithDiscount,
  imagePath,
  slug,
}) => {
  return (
    <div className="popular_box product_show items_to_slide">
      <Link
        to={`${routeConstants.PRODUCTS.path}/${slug}`}
        className="popular_imgbox"
      >
        <Image
          src={imagePath}
          alt={name}
          className="img-responsive"
          style={{ objectPosition: 'top' }}
        />
      </Link>
      <div className="popular_desc diff">
        <Link
          to={`${routeConstants.PRODUCTS.path}/${slug}`}
          className="popular_imgbox"
        >
          <h6 className="product_name">{brandName}</h6>
          <div className="mid_desc">
            <p>{name}</p>
            <p className="prc">
              ₹{basePriceWithDiscount}
              <span>
                <span className="prev_prc">₹{basePrice}</span>
              </span>
            </p>
            <p>(Incl. of all taxes)</p>
          </div>
        </Link>
        <Link
          to={`${routeConstants.PRODUCTS.path}/${slug}`}
          className="shop_btn_sm"
        >
          <span>shop now</span>
        </Link>
      </div>
    </div>
  );
};

export default SliderProductItem;
